const Purpose = {
    "Roomrent" : "Room Rent",
    "CheckoutClearance": "Check-out Clearance",
    "PlanExtension":"PlanExtension"
  };
  export default Purpose;
  